export class storeProductDetail {

    maxHeight
    productListUrl;
    product;
    breadcrumbs;
    user
    showMore = false
    isShowMore = true
    constructor(private $breadcrumbs, private $state, private $product, private $mPath, private $cart, private $user, private $sce, private MyConstant) {
        "ngInject"

    }

    $onInit() {
        this.$mPath.get('StoreListByType').then(
            response => {
                this.productListUrl = response.StoreListByType
            }
        )
        this.$user.getInfo().then(
            user => { this.user = user.data }
        )
        // this.$user.getInfo().then(user => this.user = user.data)
        this.$breadcrumbs.getByProduct({ productId: this.$state.params.pID },
            response => {
                this.breadcrumbs = response;
            }
        )
        this.$product.detail({ productId: this.$state.params.pID },
            response => {
                this.product = response;
                this.product.ManufacturerUrl = `${this.productListUrl}/productTypeID/${this.product.ProductTypeID}/defID0/${this.product.ManufacturerID}`
            }
        )
    }

    htmlDescriptionInit() {
        setTimeout(() => {
            var height = document.getElementById('description-html').clientHeight;
            if (height < 300) {
                this.isShowMore = false;
            }
            else {

            }
        }, 100)

    }

    showMores() {
        this.showMore = !this.showMore
        var height = document.getElementById('description-html').clientHeight;
        this.maxHeight = this.maxHeight ? null : height + 100 + 'px'
    }

    toTrustedHTML(html) {
        return this.$sce.trustAsHtml(html);
    }

    addToCart(vendor, salabelItem) {
        this.$cart.add(this.user, this.product, vendor, salabelItem)
    }
}



// WEBPACK FOOTER //
// ./src/components/store-product-detail/store-product-detail.controller.ts